// src/components/compliance/UploadCard.jsx
// Thin wrapper — real implementation in shared/ui/FileDropzone.jsx.
// See RaidUploadCard.jsx / TvrUploadCard.jsx for the other two pipelines
// that used to duplicate this same drag/drop logic.
import FileDropzone from "../../shared/ui/FileDropzone";
import { MAX_FILE_SIZE } from "../../utils/compliance/constants";

export default function UploadCard({ onSubmit }) {
  return (
    <FileDropzone
      theme="legacy"
      accept={[".docx", ".pdf"]}
      maxTotalSize={MAX_FILE_SIZE}
      title="Upload SOW document"
      description={
        <>
          Accepted formats: <strong>.docx</strong>.
          The SMP template bundled on the server will be used unless you provide a custom one below.
        </>
      }
      secondaryFile={{ label: "Custom template", accept: ".docx", optional: true }}
      submitLabel="Generate SMP"
      submittingLabel="Uploading…"
      onSubmit={onSubmit}
    />
  );
}
